import { lazy, Suspense } from 'react';

import { api } from '../../api.js';
import { Loading } from '../../components/ui.jsx';

/**
 * The staff's own planning: the to-do list (with the overdue count on its sidebar link), the calendar
 * of renewals, due invoices, domain expiries and tasks, and a "Tasks" tab on the admin client page.
 * (Search, export and bulk actions of the admintools module live in the shared components.)
 */
const tasks = () => import('./Tasks.jsx');
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const Tab = lazy(() => tasks().then((m) => ({ default: m.ClientTasksTab })));

function ClientTasksTab(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Tab {...props} />
    </Suspense>
  );
}

// Polled like the bell: it doesn't keep an idle staff session alive.
const overdue = () =>
  api('/api/admin/tasks/summary', { headers: { 'x-octbill-background': '1' } }).then((r) => r.data.overdue);

export default {
  name: 'admintools',
  adminRoutes: [
    { path: 'tasks', lazy: page(tasks, 'TasksPage') },
    { path: 'calendar', lazy: page(() => import('./Calendar.jsx'), 'CalendarPage') },
  ],
  adminNav: [
    {
      section: 'reports',
      to: '/admin/tasks',
      label: 'Tasks',
      permission: 'admin.tasks.read',
      order: 4,
      badge: { key: 'tasks-overdue', load: overdue, label: (n) => `${n} overdue ${n === 1 ? 'task' : 'tasks'}` },
    },
    { section: 'reports', to: '/admin/calendar', label: 'Calendar', permission: 'admin.calendar.read', order: 6 },
  ],
  adminClientTabs: [
    { key: 'tasks', label: 'Tasks', order: 85, permission: 'admin.tasks.read', Component: ClientTasksTab },
  ],
};
